module.exports = new __parcel__URL__("wbd-favicon-180.cd087db6.png").toString();